import { PendingSection1Item } from '../../../application/domain/entities/PendingSection1Item';
import { PendingSection1ItemDto } from '../dto/PendingSection1ItemDto';

export function mapPendingSection1ItemDtoToEntity(dto: PendingSection1ItemDto): PendingSection1Item {
  return {
    i9FormId: dto.i9FormId,
    firstName: dto.firstName,
    lastName: dto.lastName,
    middleName: dto.middleName,
    ssn: dto.ssn,
    hireDate: dto.hireDate ? new Date(dto.hireDate) : undefined,
    // The invite date (VTK-1851 AC5), falling back to the old reminder-only field so a client running
    // against a backend without the new column still shows what it used to rather than nothing.
    dateSent: dto.dateSent
      ? new Date(dto.dateSent)
      : dto.emailSentAt
        ? new Date(dto.emailSentAt)
        : undefined,
    createdAt: dto.createdAt ? new Date(dto.createdAt) : undefined,
    linkClickedAt: dto.linkClickedAt ? new Date(dto.linkClickedAt) : undefined,
    email: dto.email,
    canArchive: dto.canArchive ?? false,
    isAmended: dto.isAmended ?? false,
  };
}
